import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "cmd00510-input-form q-gutter-y-sm" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "col column" }
const _hoisted_14 = {
  class: "q-mb-none q-ml-sm q-mt-sm",
  style: {"word-break":"break-all"}
}
const _hoisted_15 = { class: "col column" }
const _hoisted_16 = { class: "q-mb-none q-ml-sm q-mt-sm" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col q-gutter-x-xs flex justify-end" }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import { isEmpty, isNumeric } from '../../common/utils/validateUtils';

interface Props {
  mode: string;
  deliveryTimeCode?: string;
}

const DIALOG_LEVEL = 'information';
// ダイアログのtitle

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00510',
  props: {
    mode: {},
    deliveryTimeCode: {}
  },
  setup(__props: any) {

const router = useRouter();
// 納期一覧画面からの遷移時に取得した値(mode, deliveryTimeCode)
const props = __props;
// 納期一覧画面で取得した基準納期Code
const deliveryTimeCode = ref(props.deliveryTimeCode ? props.deliveryTimeCode : '');
// 変更する納期の作成ユーザー名
const createUserName = ref('');
// 変更する納期の作成ユーザーID
const createUserId = ref('');
// 変更する納期の作成日時
const createTimestamp = ref('');
// ダイアログのdisplayFlg(表示判断)
const dialogDisplayFlg = ref(false);
// ダイアログのlevel(informationで固定)
const dialogTitle = ref('');
// ダイアログのtext(配列にすることでXSSの対策を行う)
const dialogText = ref(['']);
// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(false);
// エラーメッセージ表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');

const modeType = {
  // 登録
  MODE_REGISTER: '0',
  // 編集
  MODE_EDIT: '1',
};

// リセット用データ
const resetData = reactive({
  described_number: '',
  standard_delivery_time_code: '',
  standard_delivery_time_days: '1',
  standard_delivery_time_name: '',
});

// 入力データ
const inputData = ref({ ...resetData });

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * 入力値にエラーがなければダイアログの中身を設定
 */
const submit = () => {
  if (props.mode === modeType.MODE_REGISTER) {
    dialogTitle.value = '登録確認';
    dialogText.value = ['入力された内容で登録します。', 'よろしいですか？'];
  } else {
    dialogTitle.value = '更新確認';
    dialogText.value = ['入力された内容で更新します。', 'よろしいですか？'];
  }
  resetErrors();
  dialogDisplayFlg.value = true;
};

/**
 * クリア、リセット
 */
const reset = () => {
  resetErrors();
  inputData.value = { ...resetData };
};

/**
 * 基準納期情報取得処理(更新画面の初期表示用)
 */
const getDeliveryTime = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('standard_delivery_time_code', deliveryTimeCode.value);

  // 基準納期情報を取得するController呼び出し
  await axios
    .post('/cmd005102/getDeliveryTime', formData)
    .then((res) => {
      const { common, deliveryTimeData } = res.data;

      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          Object.assign(resetData, deliveryTimeData);
          // Integer型のデータをString型に変換
          resetData.described_number = String(deliveryTimeData.described_number);
          resetData.standard_delivery_time_days = String(
            deliveryTimeData.standard_delivery_time_days
          );
          inputData.value = { ...resetData };

          // 更新時用に作成ユーザー名、作成ユーザーID、作成日時をフィールドにセット
          createUserName.value = deliveryTimeData.create_user_name;
          createUserId.value = String(deliveryTimeData.create_user_id);
          createTimestamp.value = deliveryTimeData.create_timestamp;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 基準納期登録処理
 */
const registerDeliveryTime = async () => {
  resetErrors();
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('standard_delivery_time_code', inputData.value.standard_delivery_time_code);
  formData.append('standard_delivery_time_days', inputData.value.standard_delivery_time_days);
  formData.append('standard_delivery_time_name', inputData.value.standard_delivery_time_name);
  formData.append('described_number', inputData.value.described_number);

  // 基準納期登録を行うController呼び出し
  await axios
    .post('/cmd005101/register', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 登録確認ダイアログのtitleを設定
          dialogTitle.value = '登録完了';
          // 登録確認ダイアログのtextを生成
          dialogText.value = [
            `${inputData.value.standard_delivery_time_code} の登録が完了しました。`,
          ];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.INSERT_ERROR:
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              // メッセージチップにエラーメッセージを表示
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            case DetailResultStatusCode.DUPLICATE_DELIVERY_TIME_ERROR:
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              // メッセージチップにエラーメッセージを表示
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 基準納期変更処理
 */
const editDeliveryTime = async () => {
  resetErrors();
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('standard_delivery_time_code', inputData.value.standard_delivery_time_code);
  formData.append('standard_delivery_time_days', inputData.value.standard_delivery_time_days);
  formData.append('standard_delivery_time_name', inputData.value.standard_delivery_time_name);
  formData.append('described_number', inputData.value.described_number);
  formData.append('create_user_id', createUserId.value);
  formData.append('create_timestamp', createTimestamp.value);
  formData.append('beforeEditDeliveryTimeCode', deliveryTimeCode.value);

  // 基準納期変更を行うController呼び出し
  await axios
    .post('/cmd005102/edit', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 変更確認ダイアログのtitleを設定
          dialogTitle.value = '更新完了';
          // 変更確認ダイアログのtextを生成
          dialogText.value = [
            `${inputData.value.standard_delivery_time_code} の更新が完了しました。`,
          ];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              // メッセージチップにエラーメッセージを表示
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            case DetailResultStatusCode.DUPLICATE_DELIVERY_TIME_ERROR:
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              // メッセージチップにエラーメッセージを表示
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// propsが存在しない場合
if (!props.mode) {
  // 前画面に遷移
  router.replace({ name: 'deliveryTime' });
} else if (props.mode === modeType.MODE_EDIT) {
  getDeliveryTime();
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => [
        (_ctx.mode == modeType.MODE_REGISTER)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "納期新規登録"))
          : _createCommentVNode("", true),
        (_ctx.mode == modeType.MODE_EDIT)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "納期変更"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      onSubmit: _withModifiers(submit, ["prevent"]),
      onReset: reset,
      onValidationError: resetErrors
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "requier" }, "記載No.", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.described_number,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData.value.described_number) = $event)),
                outlined: "",
                dense: "",
                style: {"background":"var(--q-white)","width":"30%"},
                class: "input-area",
                maxlength: 9,
                rules: [
                (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                (val) => _unref(isNumeric)(val) || _ctx.$t('validation.numeric_only'),
              ],
                "lazy-rules": "",
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "requier" }, "基準納期（種別）", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.standard_delivery_time_code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.value.standard_delivery_time_code) = $event)),
                outlined: "",
                dense: "",
                style: {"background":"var(--q-white)","width":"30%"},
                class: "input-area",
                maxlength: 20,
                rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                "lazy-rules": "",
                onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "requier" }, "基準納期（日数）", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.standard_delivery_time_days,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputData.value.standard_delivery_time_days) = $event)),
                outlined: "",
                dense: "",
                style: {"background":"var(--q-white)","width":"30%"},
                maxlength: 9,
                rules: [
                (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                (val) => _unref(isNumeric)(val) || _ctx.$t('validation.numeric_only'),
              ],
                "lazy-rules": "",
                class: "input-area exception-right",
                "input-class": "text-right",
                suffix: "日",
                onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "requier" }, "基準納期名称", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.standard_delivery_time_name,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputData.value.standard_delivery_time_name) = $event)),
                outlined: "",
                dense: "",
                style: {"background":"var(--q-white)","width":"30%"},
                class: "input-area",
                maxlength: 20,
                rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                "lazy-rules": "",
                onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          (_ctx.mode == modeType.MODE_EDIT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", null, "登録者", -1)),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(createUserName.value), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", null, "登録日時", -1)),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(createTimestamp.value), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_q_btn, {
                  color: "grey-7",
                  outline: "",
                  label: "戻る",
                  style: {"min-width":"120px","background":"var(--q-white) !important"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).replace({ name: 'deliveryTime' })))
                }),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_q_btn, {
                    type: "submit",
                    color: "primary",
                    style: {"width":"150px"},
                    label: _ctx.mode === modeType.MODE_REGISTER ? '登録' : '変更'
                  }, null, 8, ["label"]),
                  _createVNode(_component_q_btn, {
                    type: "reset",
                    outline: "",
                    style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    icon: _ctx.mode === modeType.MODE_REGISTER ? 'mdi-eraser' : 'cached',
                    label: _ctx.mode === modeType.MODE_REGISTER ? 'クリア' : 'リセット'
                  }, null, 8, ["icon", "label"])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: dialogDisplayFlg.value,
      level: DIALOG_LEVEL,
      confirmation: dialogConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[9] || (_cache[9] = ($event: any) => (_unref(router).replace({ name: 'deliveryTime' }))),
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.mode === modeType.MODE_REGISTER ? registerDeliveryTime() : editDeliveryTime())),
      onClose: _cache[11] || (_cache[11] = ($event: any) => (dialogDisplayFlg.value = false))
    }, null, 8, ["display", "confirmation", "title", "text"])
  ]))
}
}

})